module.exports = __webpack_public_path__ + "media/contractor-reporting/cr-snippet-e8e15048.png";